import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import { isVideoFile } from '../utils/mediaUtils';
import { CircularProgress } from '@mui/material';

function TaggedTrippins() {
  const navigate = useNavigate();
  const [trippins, setTrippins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTaggedTrippins();
  }, []);

  const fetchTaggedTrippins = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get('/trippins/tagged');
      setTrippins(res.data);
    } catch (err) {
      console.error('Error fetching tagged trippins:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <CircularProgress size={40} sx={{ color: 'black' }} />
      </div>
    );
  }
  
  if (!Array.isArray(trippins) || trippins.length === 0) {
    return (
      <div className="loading-container" style={{ height: "unset" }}>
        <p style={{ fontSize: "18px", color: "#555", textAlign: "center", marginTop: "50px" }}>
          You have no tagged trippins yet
        </p>
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '3px', marginTop: '20px'}}>
      {trippins.map((trip) => (
        <div
          key={trip.trippin_id}
          style={{
            position: 'relative',
            width: '100%',
            paddingBottom: 'calc(100% * 4 / 3)',
            overflow: 'hidden',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          onClick={() => {
            Object.keys(sessionStorage).forEach((key) => {
              if (
                key.startsWith('selectedPhotos') ||
                key.startsWith('placeDetails') ||
                key.startsWith('background_url')
              ) {
                sessionStorage.removeItem(key);
              }
            });

            navigate(`/taggedtrippins/${trip.trippin_id}/placesSelect`);
          }}
        >
          {isVideoFile(trip.firstimageurl) ? (
            <video
              src={trip.firstimageurl}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
              autoPlay
              loop
              muted
              playsInline
            />
            ) : (
            <img
              src={trip.firstimageurl || '/placeholder.png'}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                top: 0,
                left: 0,
              }}
              alt="cover"
            />
          )}

          {/* Date top-left */}
          <div
            style={{
              position: 'absolute',
              bottom: '8px',
              width: '100%',
              textAlign: 'center',
              color: 'white',
              fontWeight: 'bold'
            }}
          >
            {new Intl.DateTimeFormat('en-GB', {
              day: '2-digit',
              month: 'short',
              year: 'numeric'
            }).format(new Date(trip.start_time))}
          </div>

          {/* Flags top-right */}
          <div
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              display: 'flex',
              gap: '4px',
              padding: '2px 4px',
              borderRadius: '4px',
            }}
          >
            {trip.countries.map((countryIso) => (
              <img
                key={countryIso}
                src={`/assets/flags/${countryIso?.toLowerCase()}.svg`}
                alt={countryIso}
                style={{ width: 20, height: 20, borderRadius: '5px' }}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default TaggedTrippins;
